import React, { Component } from 'react';
import { isEmpty, size } from "lodash";
import { Box, Table, TableBody, TableCell, TableRow, TableHead, TableFooter, TablePagination, RadioGroup, Grid  } from '@mui/material';
import SwipeableTabs from '../../../container/MUI/SwipeableTabs';
import Currency from '../../common/Currency';
import Pagination from '../../../container/MUI/Pagination';
import SpendingDetails from '../../Spendings/SpendingDetails';
import StackedStatsBank from '../../Stats/StackedStatsBank';
import { sortByDate } from '../../Stats/statsFunctions';
import SalaryDetails from '../Salary/SalaryDetails';
import Dialog from '../../common/Dialog';
import StackedStatsIn from '../../Stats/StackedStatsIn';
import { SingleRadio } from '../../common/RadioAndCheckbox';
import BankBalance from './BankBalance';
import DatePicker from '../../common/DatePicker';
import { firstDayOfYear } from '../../../utils/statsFunctions';

class BankSingle extends Component {
    state = { 
        page: 0,
        rowsPerPage: 10,
        spendings: [],
        incomes: [],
        total: 0,
        totalIncome: 0,
        graphType: this.props.income ? "incomes" : "spendings",
        filter_payment: "all",
        filter_period: "currentMonth",
        start_date: this.props.start_date || firstDayOfYear,
        end_date: this.props.end_date || new Date(),
    }
    componentDidMount = async () => {
        // this.filterSpendings()
        // this.filterIncomes()
        if(isEmpty(this.props.TRANSFERS)){
            this.props.fetchTransfers()
        } 
        if(isEmpty(this.props.INCOMES)){
            this.props.fetchIncomes()
        }   
        if(isEmpty(this.props.POSTS)){
            this.props.fetchPosts()
        }  
    }
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };

    displayLabels = (labels) => {
        const { LABELS } = this.props;
        return labels.split(', ').map(label => LABELS && LABELS[label] && LABELS[label].label_name)
    }
    filterPayments = () => {
        const { PAYMENT_DETAILS, bank } = this.props;
        const { start_date, end_date } = this.state;
        let filteredPayments = !isEmpty(PAYMENT_DETAILS) ? 
        Object.values(PAYMENT_DETAILS).filter(pay => 
            pay.payment_details_mode !== "ACOMPTE" && pay.payment_details_bank === bank.bank_id &&
            new Date(pay.payment_details_date) > start_date && new Date(pay.payment_details_date) < end_date
        ) : 
        [];

        console.log('====================================');
        console.log({ PAYMENT_DETAILS, bank, filteredPayments });
        console.log('====================================');

        return filteredPayments
    }
    // filterTransfer = () => {
    //     const { TRANSFERS, bank } = this.props;
    //     const { start_date, end_date } = this.state;
    //     let trfIn = !isEmpty(TRANSFERS) ? 
    //     Object.values(TRANSFERS).filter(pay => 
    //         pay.transfer_bank_dest === bank.bank_id &&
    //         new Date(pay.transfer_date) > start_date && new Date(pay.transfer_date) < end_date
    //     ) : 
    //     [];
    //     let trfOut = !isEmpty(TRANSFERS) ? 
    //     Object.values(TRANSFERS).filter(pay => 
    //         pay.transfer_bank_src === bank.bank_id &&
    //         new Date(pay.transfer_date) > start_date && new Date(pay.transfer_date) < end_date
    //     ) : 
    //     [];

    //     console.log('====================================');
    //     console.log({ TRANSFERS, bank, trfIn, trfOut });
    //     console.log('====================================');

    //     return {
    //         trfIn,
    //         trfOut,
    //     }
    // }
    findSpendingType = (payment) => {
        const { SPENDINGS, SALARIES, CHARGES, SUPPLIERS, USERS } = this.props;
        let spending = {}

        if(!isEmpty(payment.payment_spending_id)){
            spending = Object.assign({}, SPENDINGS[payment.payment_spending_id])

        } else if(!isEmpty(payment.payment_salary_id)){

            spending = Object.assign({}, SALARIES[payment.payment_salary_id])
            spending.spending_category = spending.salary_category

        } else if(!isEmpty(payment.payment_charge_id)){

            spending = Object.assign({}, CHARGES[payment.payment_charge_id])
            spending.spending_category = spending.salary_line_name
            
        } else if(payment.payment_is_supplier_advance){
            spending = Object.assign({}, SUPPLIERS[payment.payment_details_supplier])
            spending.spending_supplier = spending.supplier_id
            spending.spending_category = spending.supplier_name
            spending.spending_desc = "ACOMPTE"
            
        } else if(payment.payment_is_avance){
            spending = Object.assign({}, USERS[payment.payment_details_collaborator])
            spending.spending_collaborator = `${spending.username} ${spending.lastname}`
            spending.spending_category = spending.supplier_name
            spending.spending_desc = "AVANCE"
            
        }
        
        return spending
    }
    filterSpendings = () => {
        const { SPENDINGS, TRANSFERS } = this.props;
        let filterPayment = this.filterPayments()
        let filteredList = []
        let total = 0
        
        if ( !isEmpty(SPENDINGS) && !isEmpty(filterPayment) ) {
            
            filterPayment.forEach( payment => {
                let spending = this.findSpendingType(payment)
                spending.amount_bank = payment.payment_amount
                spending.payment_date = payment.payment_details_date
                spending.payment_id = payment.payment_details_id

                filteredList.push(spending)
                total += payment.payment_amount
            }) 

        }
        // if ( !isEmpty(TRANSFERS) ) {
        //     Object.values(TRANSFERS).forEach( payment => {
        //         let spending = this.findSpendingType(payment)
        //         spending.amount_bank = payment.transfer_amount
        //         spending.payment_date = payment.transfer_date
        //         spending.payment_id = payment.transfer_id

        //         filteredList.push(spending)
        //         total += payment.transfer_amount
        //     }) 
        // }
        let sortedList = sortByDate(filteredList, "payment_date").reverse()
        // this.setState({
        //     spendings: sortedList,
        //     total
        // })
        return {list: sortedList, total}
    }
    displaySpendings = () => {
        const { rowsPerPage, page } = this.state;
        const { CATEGORIES, SUPPLIERS, LABELS, USERS } = this.props;
        let spendings = this.filterSpendings()

        return [spendings.list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map( item => {
            let category = CATEGORIES.CHILD[item.spending_category]
            // let user = isEmpty(USERS) ? {} : USERS[item.spending_user]
            let labels = LABELS && item.spending_labels && this.displayLabels(item.spending_labels)
            let supplier = isEmpty(SUPPLIERS) ? {} : SUPPLIERS[item.spending_supplier]
            

            return (
                <TableRow 
                    hover
                    key={item.payment_id}
                    onClick={() => this.setState({openDetails: true, selectedSpending: item }) }
                >
                    <TableCell >
                        {new Date(item.payment_date).toLocaleDateString('fr-FR')}
                    </TableCell>
                    <TableCell >{ category && category.category_name}</TableCell>                     
                    <TableCell >{item.spending_desc}</TableCell>   
                    <TableCell >{supplier && supplier.supplier_name ? supplier.supplier_name : item.spending_collaborator}</TableCell>   
                    <TableCell >{labels && labels.join(", ")}</TableCell>   
                    <TableCell ><Currency value={item.amount_bank} /></TableCell>                     
                    {/* 
                        <TableCell >
                            {!item.spending_fully_paid &&
                                <Currency value={item.spending_rest_to_pay} />
                            }
                        </TableCell>
                    */}
                    
                </TableRow>
            )
        }), spendings.list, spendings.total]
    }
    filterIncomes = () => {
        const { INCOMES, bank  } = this.props;
        const { start_date, end_date } = this.state;
        let filteredList = []
        let totalIncome = 0
        
        if ( !isEmpty(INCOMES) ) {
            filteredList = Object.values(INCOMES).filter( income => 
                income.income_bank === bank.bank_id &&
                new Date(income.income_date) >= start_date &&
                new Date(income.income_date) <= end_date 
            )
        }

        let sortedList = sortByDate(filteredList, "income_date").reverse()
        // this.setState({
        //     incomes: sortedList,
        //     totalIncome
        // })
        return {list: sortedList, totalIncome}
    }
    displayIncomes = () => {
        const { rowsPerPage, page } = this.state;
        const { POSTS } = this.props;
        let incomes = this.filterIncomes()

        return [incomes.list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map( item => {
            let post = isEmpty(POSTS) ? {} : POSTS[item.income_post]
            
            return (
                <TableRow 
                    hover
                    key={item.income_id}
                    onClick={() => this.setState({openDetails: true, selectedIncome: item }) }
                >
                    <TableCell >
                        {new Date(item.income_date).toLocaleDateString('fr-FR')}
                    </TableCell>
                    <TableCell>{post && post.post_name}</TableCell>   
                    <TableCell>{item.income_desc}</TableCell>   
                    <TableCell><Currency value={item.income_amount} /></TableCell>                     
                    <TableCell>{item.income_payment_mode}</TableCell>   
                </TableRow>
            )
        }), incomes.list, incomes.totalIncome]
    }
    render() {
        const { bank, CATEGORIES, SUPPLIERS, PAYMENTS, BANKS, LABELS, SPENDINGS, EMPLOYEES, SALARY_CATS, SERVICES, FUNCTIONS, POSTS } = this.props;
        const { rowsPerPage, page, selectedSpending, openDetails, graphType} = this.state;
        let spendings = !isEmpty(CATEGORIES.CHILD) ? this.displaySpendings() : []
        let incomes = !isEmpty(POSTS) ?  this.displayIncomes() : []
        console.log("STATE", this.state, size(spendings[0]));
        return (
            <Dialog
                close={this.props.handleClose}
                maxWidth="lg"
                fullScreen
                scroll="paper"
                title={bank.bank_name}
                appBar
            >
                {openDetails && selectedSpending && selectedSpending.spending_id &&
                    <SpendingDetails 
                        supplier={SUPPLIERS && SUPPLIERS[selectedSpending.spending_supplier]} 
                        LABELS={LABELS}
                        BANKS={BANKS}
                        PAYMENTS={PAYMENTS}
                        // SPENDINGS={SPENDINGS}
                        category={CATEGORIES.CHILD && CATEGORIES.CHILD[selectedSpending.spending_category]} 
                        spending={SPENDINGS[selectedSpending.spending_id]} // to have latest update of props
                        view="ADMIN"
                        handleClose={()=> this.setState({openDetails: false, selectedSpending: {}})}
                        fetchSpendingPayments={this.props.fetchSpendingPayments}
                    />
                }
                {openDetails && selectedSpending && selectedSpending.salary_id &&
                    <SalaryDetails 
                        handleClose={()=> this.setState({openDetails: false, selectedSpending: {}})} 
                        EMPLOYEES={EMPLOYEES}
                        SERVICES={SERVICES}
                        FUNCTIONS={FUNCTIONS}
                        SALARY_CATS={SALARY_CATS}
                        salary={selectedSpending} 
                    />
                }
                
                <Box>
                    <Grid container>
                        <Grid item xs={12} sm={6} >
                            <DatePicker
                                required
                                label="Du"
                                handleChange={(date)=> this.setState({ start_date: date})}
                                value={this.state.start_date}
                                id="start_date"
                                maxDate={this.state.end_date || new Date()}

                            />
                        </Grid>
                        <Grid item xs={12} sm={6} >
                            <DatePicker
                                required
                                label="Au"
                                handleChange={(date)=> this.setState({ end_date: date})}
                                value={this.state.end_date}
                                id="end_date"
                                maxDate={new Date()}
                                minDate={this.state.start_date || new Date()}
                            />
                        </Grid>
                    </Grid>
                    <SwipeableTabs
                        labels={["Statistiques", "Balance", "Dépenses", "Recettes"]}
                    >
                        <Box p={3}>
                            {/* Total: <Currency value={total} /> */}
                            <RadioGroup
                                aria-label="Vues"
                                style={{ flexDirection: 'row' }}
                                name="views"
                                value={graphType}
                                onChange={(e) => this.setState({ graphType: e.target.value})}
                            >
                                <SingleRadio value="spendings" label="Dépenses"/>
                                <SingleRadio value="incomes" label="Recettes"/>
                            </RadioGroup>
                            {graphType === "spendings" ? 
                                <StackedStatsBank
                                    CATEGORIES={CATEGORIES.CHILD}
                                    SPENDINGS={spendings[1]}
                                    budget_year={this.props.budget_year}
                                    noDateFilter
                                    {...this.state}
                                />
                                :
                                <StackedStatsIn
                                    POSTS={POSTS}
                                    INCOMES={incomes[1]}
                                    budget_year={this.props.budget_year}
                                    noDateFilter
                                    fieldBy="income_post"
                                    fieldName="post_name" 
                                    {...this.state}
                                />
                            }
                        </Box>
                        <Box p={3} style={{ maxHeight: "65vh"}}>
                            <BankBalance
                                {...this.props}
                                {...this.state}
                            />
                        </Box>
                        <Box p={3} style={{ maxHeight: "65vh"}}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                    <TableCell>Créé le</TableCell>
                                        <TableCell>Catégorie</TableCell>
                                        <TableCell>Description</TableCell>
                                        <TableCell>Fournisseur</TableCell>
                                        <TableCell>Labels</TableCell>
                                        <TableCell>Montant</TableCell>
                                        {/* <TableCell>Reste à Payer</TableCell> */}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {!isEmpty(CATEGORIES.CHILD) && 
                                    // {!isEmpty(spendings) && !isEmpty(CATEGORIES.CHILD) && 
                                        spendings[0]
                                    }
                                </TableBody>
                                {size(spendings[1]) > 10 &&
                                    <TableFooter>
                                        <TableRow>
                                            <TablePagination
                                                rowsPerPageOptions={[10, 30]}
                                                labelRowsPerPage="Lignes par Page"
                                                colSpan={7}
                                                count={size(spendings[1])}
                                                rowsPerPage={rowsPerPage}
                                                page={page}
                                                SelectProps={{
                                                    native: true,
                                                }}
                                                onPageChange={this.handleChangePage}
                                                onRowsPerPageChange={this.handleChangeRowsPerPage}
                                                ActionsComponent={Pagination}
                                            />
                                        </TableRow>
                                    </TableFooter>
                                }
                            </Table>
                        </Box>
                        <Box p={3} style={{ maxHeight: "65vh"}}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                    <TableCell>Créé le</TableCell>
                                        <TableCell>Poste</TableCell>
                                        <TableCell>Description</TableCell>
                                        <TableCell>Montant</TableCell>
                                        <TableCell>Mode</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {!isEmpty(POSTS) && 
                                    // {!isEmpty(incomes) && !isEmpty(POSTS) && 
                                        incomes[0]
                                    }
                                </TableBody>
                                {size(incomes[1]) > 10 &&
                                    <TableFooter>
                                        <TableRow>
                                            <TablePagination
                                                rowsPerPageOptions={[10, 30]}
                                                labelRowsPerPage="Lignes par Page"
                                                colSpan={7}
                                                count={size(incomes[1])}
                                                rowsPerPage={rowsPerPage}
                                                page={page}
                                                SelectProps={{
                                                    native: true,
                                                }}
                                                onPageChange={this.handleChangePage}
                                                onRowsPerPageChange={this.handleChangeRowsPerPage}
                                                ActionsComponent={Pagination}
                                            />
                                        </TableRow>
                                    </TableFooter>
                                }
                            </Table>
                        </Box>
                    </SwipeableTabs>
                </Box>
            </Dialog>
        );
    }
}

export default BankSingle;